import LocalStorage from "@/general/utils/storage";
// User Tag - https://support.karte.io/post/1PyezQBU7DNg7bESwTcypm
export default function karteUser() {
  try {
    if ("tracker" in window) {
      const userDetails = JSON.parse(
        LocalStorage.getItem("userDetails") as string
      );
      let userid = "";
      try {
        userid = userDetails.id;
      } catch (exception_var) {
        userid = userDetails.userId;
      }
      (window as any).tracker.track("identify", {
        user_id: userid,
        email: userDetails.email,
        first_name: userDetails.first_name,
        last_name: userDetails.last_name,
        corporate_id: userDetails.organization
      });
    }
  } catch (e) {
	if (e instanceof Error) {
	    if ("tracker" in window) {
	      (window as any).tracker.track("_error", {
	        message: e.message
	      });
	    }
	}
  }
}
